var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.30002H10.3V4.20002C10.3 2.66002 9.04005 1.40002 7.50005 1.40002C5.96005 1.40002 4.70005 2.66002 4.70005 4.20002V6.30002H4.00005C3.65005 6.30002 3.30005 6.65002 3.30005 7.00002V11.9C3.30005 12.25 3.65005 12.6 4.00005 12.6H11C11.35 12.6 11.7 12.25 11.7 11.9V7.00002C11.7 6.65002 11.35 6.30002 11 6.30002ZM8.20005 11.2H6.80005L7.08005 9.66002C6.73005 9.52002 6.45005 9.10002 6.45005 8.75002C6.45005 8.19002 6.94005 7.70002 7.50005 7.70002C8.06005 7.70002 8.55005 8.19002 8.55005 8.75002C8.55005 9.17002 8.34005 9.52002 7.92005 9.66002L8.20005 11.2ZM8.90005 6.30002H6.10005V4.20002C6.10005 3.43002 6.73005 2.80002 7.50005 2.80002C8.27005 2.80002 8.90005 3.43002 8.90005 4.20002V6.30002Z",
    fill: "#6B7280"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.fc43b09f.svg";
export { ForwardRef as ReactComponent };